import Game from "../../core/engine/game";
import { IGame } from "../../core/engine/types/game";
import UnifiedInputManager from "../managers/unified-input-manager";
import { IInputSource } from "../managers/input-source";
import LocalPlayer from "../../core/engine/models/impl/local-player";
import RemotePlayer from "../../core/engine/models/impl/remote-player";

import AudioManager from "../managers/audio-manager";

function createLocalGame(
  screen?: HTMLCanvasElement,
  width: number = 400,
  scale: number = 1,
  inputSources: IInputSource[] = [],
  gameSeed?: number
) {
  console.log(`[createLocalGame] Creating new game instance...`);
  
  // Create unified input manager that combines all provided input sources
  const input = new UnifiedInputManager();
  inputSources.forEach(source => input.addInputSource(source));
  
  const player = new LocalPlayer();
  const audioManager = new AudioManager();
  const game: Game = new Game(player, audioManager, gameSeed); // Pass gameSeed to ensure correct RNG initialization
  console.log(
    `[createLocalGame] Game created, canvas instance #${
      (game.canvas as any).instanceId ?? "unknown"
    }${gameSeed !== undefined ? `, seed=${gameSeed}` : ""}`
  );
  game.input = input;

  // game.onPacketSent(packet => {
  //     for(var i=0; i<callbacks.length; i++){
  //         callbacks[i](packet);
  //     }
  // });

  return {
    game,
    unifiedInput: input,
  };
}

function createRemoteGame(
  screen: HTMLCanvasElement,
  packets: any[],
  width: number = 400,
  scale: number = 1
): IGame {
  const player = new RemotePlayer(packets);
  const audioManager = new AudioManager(); // Remote games need audio manager too (even if silent/unused)
  const game: Game = new Game(player, audioManager);
  return game;
}

export { createLocalGame, createRemoteGame };
